import {getCookie, getCookieName} from '../../common/utils/cookieUtils'
import {ApiService} from '../ApiService'
import {
  CreateXpertKnowledgeSectionBody,
  CreateXpertKnowledgeSubSectionBody,
  UpdateXpertKnowledgeSectionBody,
  UpdateXpertKnowledgeSubclipBody,
  UpdateXpertKnowledgeSubSectionBody,
  XpertKnowledgeSectionDto,
  XpertKnowledgeSubSectionDto,
} from './type'

class XpertKnowledgeSectionServiceProvider extends ApiService {
  async getAllSection(xpertKnowledgeId: string, tutorialId: number): Promise<XpertKnowledgeSectionDto[]> {
    return this.get<XpertKnowledgeSectionDto[]>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/section`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async createSection(xpertKnowledgeId: string, tutorialId: number, body: CreateXpertKnowledgeSectionBody): Promise<XpertKnowledgeSectionDto> {
    return this.post<XpertKnowledgeSectionDto>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/section`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async createSubSection(
    xpertKnowledgeId: string,
    tutorialId: number,
    sectionId: number,
    body: CreateXpertKnowledgeSubSectionBody
  ): Promise<XpertKnowledgeSubSectionDto> {
    return this.post<XpertKnowledgeSubSectionDto>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/section/${sectionId}/sub`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async updateSection(
    xpertKnowledgeId: string,
    tutorialId: number,
    sectionId: number,
    body: UpdateXpertKnowledgeSectionBody
  ): Promise<XpertKnowledgeSectionDto> {
    return this.patch<XpertKnowledgeSectionDto>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/section/${sectionId}`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async updateSubclip(
    xpertKnowledgeId: string,
    tutorialId: number,
    sectionId: number,
    subSectionId: number,
    body: UpdateXpertKnowledgeSubclipBody
  ): Promise<XpertKnowledgeSubSectionDto> {
    return this.patch<XpertKnowledgeSubSectionDto>(
      `/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/section/${sectionId}/sub/${subSectionId}/subclip`,
      body,
      {
        headers: {
          Authorization: `Bearer ${getCookie(getCookieName())}`,
        },
      }
    )
  }

  async updateSubSection(
    xpertKnowledgeId: string,
    tutorialId: number,
    sectionId: number,
    subSectionId: number,
    body: UpdateXpertKnowledgeSubSectionBody
  ): Promise<XpertKnowledgeSubSectionDto> {
    return this.patch<XpertKnowledgeSubSectionDto>(
      `/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/section/${sectionId}/sub/${subSectionId}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${getCookie(getCookieName())}`,
        },
      }
    )
  }

  async deleteSection(xpertKnowledgeId: string, tutorialId: number, sectionId: number): Promise<void> {
    return this.delete<void>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/section/${sectionId}`, null, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async deleteSubSection(xpertKnowledgeId: string, tutorialId: number, sectionId: number, subSectionId: number): Promise<void> {
    return this.delete<void>(`/xpert-knowledge/${xpertKnowledgeId}/tutorial/${tutorialId}/section/${sectionId}/sub/${subSectionId}`, null, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }
}

export const XpertKnowledgeSectionService = new XpertKnowledgeSectionServiceProvider()
